// Generated by Melange

import * as Buhta_cabinet__Button from "../../../html/Button.js";
import * as Buhta_cabinet__Link from "../../../html/Link.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function Contract(Props) {
  let org = Props.org;
  const tab1 = "Договор и приложения";
  const tab2 = "история";
  const match = React.useState(function () {
        return tab1;
      });
  const setTab = match[1];
  const tab = match[0];
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                              route: {
                                TAG: /* Org */6,
                                _0: org.id,
                                _1: {
                                  TAG: /* Documents */1,
                                  _0: {
                                    TAG: /* Contracts */0,
                                    _0: /* List */0
                                  }
                                }
                              },
                              children: JsxRuntime.jsx("img", {
                                    className: "w-5 h-5",
                                    src: StaticAsset.src("/static/icons/close-20.svg")
                                  })
                            }),
                        JsxRuntime.jsx("img", {
                              alt: "Buhta",
                              src: StaticAsset.src("/static/icons/Union.svg")
                            })
                      ],
                      className: "py-4 px-6 flex items-center justify-between border-b border-gray-main"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("img", {
                                      className: "pr-2",
                                      src: StaticAsset.src("/static/icons/Rectangle.svg")
                                    }),
                                JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                      className: "text-gray-medium",
                                      children: "Исходящий"
                                    })
                              ],
                              className: "flex pl-0"
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                              className: "text-gray-medium",
                              children: "15.09.2019 17:22:20"
                            })
                      ],
                      className: "flex justify-between p-6 pt-3"
                    }),
                JsxRuntime.jsx(Buhta_components__Text.H1.make, {
                      className: "p-6 pt-3",
                      children: "Разработка дизайна корпоративного сайта"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      className: "w-[168px]",
                                      children: "Номер"
                                    }),
                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "276224"
                                    })
                              ],
                              className: "flex gap-4 pb-1"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      className: "w-[168px]",
                                      children: "Дата подписания"
                                    }),
                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "15.09.2019 17:22:20"
                                    })
                              ],
                              className: "flex gap-4 pb-4"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      className: "w-[168px]",
                                      children: "Кому"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "font-mediumbold",
                                              children: "ТОО \"PS Engineering\""
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                      children: "docs@ps-engineering.kz"
                                                    }),
                                                JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                      className: "pl-1 text-links",
                                                      children: "Изменить"
                                                    })
                                              ],
                                              className: "flex"
                                            })
                                      ]
                                    })
                              ],
                              className: "flex gap-4 pb-4"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      className: "w-[168px]",
                                      children: "От"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "font-mediumbold",
                                              children: "ТОО \"Бухта\""
                                            }),
                                        JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                              children: "Нурпеисов А. К."
                                            })
                                      ]
                                    })
                              ],
                              className: "flex gap-4"
                            })
                      ],
                      className: "flex-col p-6 pb-15 pt-0"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("a", {
                                    children: JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                          className: "text-gray-medium",
                                          children: tab1
                                        }),
                                    className: Cn.fromList({
                                          hd: "py-2.5 grow lg:grow-0",
                                          tl: {
                                            hd: "cursor-pointer block",
                                            tl: /* [] */0
                                          }
                                        }),
                                    onClick: (function (param) {
                                        Curry._1(setTab, (function (param) {
                                                return tab1;
                                              }));
                                      })
                                  }),
                              JsxRuntime.jsx("a", {
                                    children: JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                          className: "text-gray-medium",
                                          children: tab2
                                        }),
                                    className: Cn.fromList({
                                          hd: "py-2.5 grow lg:grow-0",
                                          tl: {
                                            hd: "cursor-pointer block",
                                            tl: /* [] */0
                                          }
                                        }),
                                    onClick: (function (param) {
                                        Curry._1(setTab, (function (param) {
                                                return tab2;
                                              }));
                                      })
                                  })
                            ],
                            className: "bg-white px-2 lg:px-6 border-b border-gray-main w-full flex justify-between lg:justify-start lg:gap-4"
                          }),
                      className: "w-full flex flex-col items-center"
                    }),
                Caml_obj.caml_equal(tab, tab1) ? JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                        children: "Документы от 10 ноября"
                                                      }),
                                                  JsxRuntime.jsx("img", {
                                                        alt: "buhta-arrow",
                                                        src: StaticAsset.src("/static/icons/Default.svg")
                                                      })
                                                ],
                                                className: "flex gap-3 items-center"
                                              }),
                                          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                className: "text-gray-medium",
                                                children: "Договор и приложение"
                                              })
                                        ],
                                        className: "flex-col gap-1 "
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("img", {
                                                className: "pl-2",
                                                alt: "arrow-buhta",
                                                src: StaticAsset.src("/static/icons/Done.svg")
                                              }),
                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                className: "text-success",
                                                children: "Подписан"
                                              })
                                        ],
                                        className: "flex items-center w-27 h-7 bg-green-zing rounded-3xl gap-1"
                                      })
                                ],
                                className: "flex justify-between gap-3 w-161 px-4 py-3 border rounded-md relative items-center mb-4"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                children: "Документы от 23 ноября"
                                                              }),
                                                          JsxRuntime.jsx("img", {
                                                                alt: "buhta-arrow",
                                                                src: StaticAsset.src("/static/icons/Dropdown-black.svg")
                                                              })
                                                        ],
                                                        className: "flex gap-3 items-center"
                                                      }),
                                                  JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                        className: "text-gray-medium",
                                                        children: "2 приложения"
                                                      })
                                                ],
                                                className: "flex-col gap-1"
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("img", {
                                                        className: "pl-2",
                                                        alt: "arrow-buhta",
                                                        src: StaticAsset.src("/static/icons/files.svg")
                                                      }),
                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                        className: "text-gray-medium",
                                                        children: "Создан"
                                                      })
                                                ],
                                                className: "flex items-center w-22.5 h-7 bg-gray-pale rounded-3xl gap-2"
                                              })
                                        ],
                                        className: "flex justify-between gap-3 relative items-center"
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("img", {
                                                className: "rounded border",
                                                src: StaticAsset.src("/static/icons/dogovor.svg")
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                                        children: "Приложение #2"
                                                      }),
                                                  JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                        className: "text-gray-medium",
                                                        children: "Приложение"
                                                      })
                                                ],
                                                className: "flex-col gap-1 "
                                              }),
                                          JsxRuntime.jsx("img", {
                                                className: "absolute right-6 top-1/2 -translate-y-1/2",
                                                alt: "arrow-buhta",
                                                src: StaticAsset.src("/static/icons/Union.svg")
                                              })
                                        ],
                                        className: "flex gap-3 w-159 pt-5 relative"
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("img", {
                                                className: "rounded border",
                                                src: StaticAsset.src("/static/icons/dogovor.svg")
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                                        children: "Приложение #3"
                                                      }),
                                                  JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                        className: "text-gray-medium",
                                                        children: "Приложение"
                                                      })
                                                ],
                                                className: "flex-col gap-1 "
                                              }),
                                          JsxRuntime.jsx("img", {
                                                className: "absolute right-6 top-1/2 -translate-y-1/2",
                                                alt: "arrow-buhta",
                                                src: StaticAsset.src("/static/icons/Union.svg")
                                              })
                                        ],
                                        className: "flex gap-3 w-159 py-3 relative"
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("img", {
                                                className: "w-8 h-10",
                                                src: StaticAsset.src("/static/icons/plus-bordered.svg")
                                              }),
                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                children: "Добавить приложение"
                                              })
                                        ],
                                        className: "flex gap-3 mt-1 mb-3 items-center"
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs(Buhta_cabinet__Button.make, {
                                                size: "s",
                                                className: "flex gap-2 items-center",
                                                children: [
                                                  JsxRuntime.jsx("img", {
                                                        alt: "sign-buhta",
                                                        src: StaticAsset.src("/static/icons/sign.svg")
                                                      }),
                                                  "Подписать документы"
                                                ]
                                              }),
                                          JsxRuntime.jsxs(Buhta_cabinet__Button.make, {
                                                size: "s",
                                                kind: "default",
                                                className: "flex items-center gap-2",
                                                children: [
                                                  JsxRuntime.jsx("img", {
                                                        alt: "sign-buhta",
                                                        src: StaticAsset.src("/static/icons/Vector 2.svg")
                                                      }),
                                                  "Отправить на рассмотрение"
                                                ]
                                              })
                                        ],
                                        className: "flex justify-end gap-2"
                                      })
                                ],
                                className: "flex-col w-161 px-4 py-3 border rounded-md"
                              })
                        ],
                        className: "p-6 "
                      }) : (
                    Caml_obj.caml_equal(tab, tab2) ? JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("img", {
                                                    alt: "Buhta",
                                                    height: "20px",
                                                    src: StaticAsset.src("/static/icons/Buhta.svg"),
                                                    width: "20px"
                                                  }),
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "font-mediumbold",
                                                    children: "Бухта"
                                                  })
                                            ],
                                            className: "flex w-76 bg-gray-pale rounded-md h-9.5 items-center gap-2 pl-4"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("img", {
                                                    alt: "Buhta",
                                                    height: "20px",
                                                    src: StaticAsset.src("/static/icons/logo-company.svg"),
                                                    width: "20px"
                                                  }),
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "font-mediumbold",
                                                    children: "ТОО \"PS Engineering\""
                                                  })
                                            ],
                                            className: "flex w-76 bg-gray-pale rounded-md h-9.5 items-center gap-2 pl-4"
                                          })
                                    ],
                                    className: "flex justify-between pb-4"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("img", {
                                                            alt: "Buhta",
                                                            height: "20px",
                                                            src: StaticAsset.src("/static/icons/Photo.svg"),
                                                            width: "20px"
                                                          }),
                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "font-mediumbold",
                                                            children: "Рауан М. "
                                                          }),
                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            children: "создал договор"
                                                          })
                                                    ],
                                                    className: "flex gap-2 justify-end "
                                                  }),
                                              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                    className: "text-right w-76 text-gray-medium",
                                                    children: "10.02, Вт 12:05"
                                                  })
                                            ],
                                            className: "flex-col w-76"
                                          }),
                                      JsxRuntime.jsx("img", {
                                            alt: "Buhta",
                                            height: "20px",
                                            src: StaticAsset.src("/static/icons/docies.svg"),
                                            width: "20px"
                                          })
                                    ],
                                    className: "flex items-start justify-between w-85"
                                  })
                            ],
                            className: "flex-col p-6 "
                          }) : null
                  )
              ],
              className: "border-l border-gray-main shrink-0 flex flex-col w-177"
            });
}

const make = Contract;

export {
  make ,
}
/* Buhta_cabinet__Button Not a pure module */
